module.exports = __webpack_public_path__ + "img/wf-finishing-position-7.23d7e6fd.svg";